<script>
 import axios from "axios";
 import {ItemPath} from "@/path";

 export default  {
   props : ['data'],
   data() {
     return {
       cdn : process.env.VUE_APP_AWS_CDN,
       baseUrl : process.env.VUE_APP_API_BACKEND_URL
     }
   },
   methods : {
     async deleteImage(id){
       try {
         let res = await axios.delete(this.baseUrl + ItemPath.DELETE_IMAGE,{
           params : {
             id : id
           }
         });
         if(res.data.status){
           this.data.images = this.data.images.splice(id,1);
           // this.$emit('setImages',this.data);
         }
       }catch (e){
         console.log(e);
       }
     }
   }
 }
</script>

<template>
  <div>
    <b-row v-for="(im,imk) in data.images" :key="imk">
      <b-col size="6">
        <b-img :src="cdn + '/' + im.img_url" height="100"></b-img>
      </b-col>
      <b-col size="6">
        <b-button variant="danger" @click="deleteImage(im.id)"><i class="fa fa-trash"></i></b-button>
      </b-col>
    </b-row>
  </div>
</template>

<style>

</style>